import type { ThinkingMessageDisplay } from '@/types'
import {
  Reasoning,
  ReasoningContent,
  ReasoningTrigger,
} from '@/components/ai/reasoning'

interface ThinkingMessageProps {
  event: ThinkingMessageDisplay
}

export function ThinkingMessage({ event }: ThinkingMessageProps) {
  return (
    <Reasoning
      className="mb-0 py-2"
      defaultOpen={false}
      isStreaming={event.isStreaming}>
      <ReasoningTrigger className="opacity-70 hover:opacity-100 data-[state=open]:opacity-100 text-primary-high-contrast hover:text-primary-high-contrast font-medium leading-4 tracking-[-0.28px] cursor-pointer" />
      <ReasoningContent className="mt-2 ml-2 border-l border-primary-high-contrast/10 pl-4 text-david-high-contrast text-sm font-medium leading-normal">
        {event.content}
      </ReasoningContent>
    </Reasoning>
  )
}
